import { eventQBus } from "../types/EventQBus";
import type { DresonRuleResolvedEvent } from "./FilterTypes";
import { LoadFilter } from "./LoadFilter";
import { TsBct } from "./TsBct";
import { addFeaturesToPageImpressionTracking } from "../tracking/FeatureTracking";
import { Filter } from "../filter/Filter";
import { addSanErrorToPageImpression, FILTER_FEATURES } from "../filter/FilterTracking";
import { FilterSection } from "../filter/FilterSection";
import { events } from "../events";

export function registerFilterReloading() {
  eventQBus.on("ftfind.dresonRule.resolved", (data: DresonRuleResolvedEvent) => {
    if (data && data.rule !== FilterSection.template().currentDresonRule) {
      if (data.count === 0) {
        Filter.handleError();
        addSanErrorToPageImpression("filterlist_empty");
        addFeaturesToPageImpressionTracking(FILTER_FEATURES);
      } else {
        events.filterSectionLoad(data.rule, data.page, TsBct.sfid());
      }
    }
  });

  eventQBus.on("ftfind.dresonRule.resolveAborted", Filter.handleError);

  events.onFilterSectionLoad(LoadFilter.onLoadFilters);
  events.onFilterSectionInitialLoaded(LoadFilter.onInitialLoadedFilters);
}
